import type { TypeFormFieldElement } from '../../../types/form';

// ----------------------------------------------------------------------------

function getValidationName(field: TypeFormFieldElement): string {
    return (field.dataset.fieldName ?? field.name ?? '').trim();
}

// ----------------------------------------------------------------------------

export default getValidationName;
